import { render, staticRenderFns } from "./GinIndexadjust.vue?vue&type=template&id=324d1584&scoped=true"
import script from "./GinIndexadjust.vue?vue&type=script&lang=js"
export * from "./GinIndexadjust.vue?vue&type=script&lang=js"
import style0 from "./GinIndexadjust.vue?vue&type=style&index=0&id=324d1584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d1584",
  null
  
)

export default component.exports